import {
  getSales,
  getTicketPackages,
  getDiscountCoupon,
  cancelTicket,
} from "@/api";

const state = {
  sales: [],
  salesLoading: false,
  discountCoupon: [],
  discountCouponLoading: false,
  ticketPackages: [],
  loadingPackages: false,
  cancelOrderDialog: false,
  cancelTicketDialog: false,
  loadingExportCSV: false,
  loadingExportPDF: false,
};

const getters = {
  allSales: state => state.sales,
  salesLoading: state => state.salesLoading,
  allTicketPackages: state => state.ticketPackages,
  loadingPackages: state => state.loadingPackages,
  cancelOrderDialog: state => state.cancelOrderDialog,
  cancelTicketDialog: state => state.cancelTicketDialog,
  loadingExportCSV: state => state.loadingExportCSV,
  loadingExportPDF: state => state.loadingExportPDF,
};

const actions = {
  fetchSales({ commit }, params) {
    commit("setSalesLoading", true);
    const { producerId, ...rest } = params;
    getSales(producerId, rest).then(response => {
      commit("setSales", response.data);
      commit("setSalesLoading", false);
    });
  },
  async exportSales({ commit, dispatch }, params) {
    const { exportation } = params;
    exportation === "CSV"
      ? commit("setLoadingExportCSV", true)
      : commit("setLoadingExportPDF", true);

    try {
      const response = await getSales(params);
      const exportationType =
        exportation === "CSV" ? "text/csv" : "application/pdf";
      const file = new Blob([response.data], { type: exportationType });
      const fileURL = URL.createObjectURL(file);

      if (exportation === "CSV") {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = `Vendas.csv`;
        a.click();
        window.URL.revokeObjectURL(fileURL);
      } else {
        window.open(fileURL);
      }
    } catch (error) {
      dispatch("showSnackbarError", error.response.data.message);
    } finally {
      commit("setLoadingExportCSV", false);
      commit("setLoadingExportPDF", false);
    }
  },
  fetchDiscountCoupon({ commit }, params) {
    commit("setDiscountCouponLoading", true);
    const { producerId, ...rest } = params;
    getDiscountCoupon(producerId, rest).then(response => {
      commit("setDiscountCoupon", response.data);
      commit("setDiscountCouponLoading", false);
    });
  },
  fetchTicketPackages({ commit }, params) {
    commit("setLoadingPackages", true);
    const { producerId, ...rest } = params;
    getTicketPackages(producerId, rest).then(response => {
      commit("setTicketPackages", response.data);
      commit("setLoadingPackages", false);
    });
  },
  cancelOrderTicket({ dispatch }, params) {
    const {
      loja,
      iditem,
      idpedido_marketplace,
      ano_mes,
      motivo_cancelamento,
      idconsumidor,
    } = params;

    cancelTicket(
      loja,
      iditem,
      idpedido_marketplace,
      ano_mes,
      motivo_cancelamento,
      idconsumidor
    ).then(() => {
      dispatch("showSnackbarSuccess", "Ingresso cancelado com sucesso!");
    });
  },
};

const mutations = {
  toggleCancelOrderDialog(state) {
    state.cancelOrderDialog = !state.cancelOrderDialog;
  },
  toggleCancelTicketDialog(state) {
    state.cancelTicketDialog = !state.cancelTicketDialog;
  },
  setSales(state, sales) {
    state.sales = sales;
  },
  setSalesLoading(state, salesLoading) {
    state.salesLoading = salesLoading;
  },
  setDiscountCoupon(state, discountCoupon) {
    state.discountCoupon = discountCoupon;
  },
  setDiscountCouponLoading(state, discountCouponLoading) {
    state.discountCouponLoading = discountCouponLoading;
  },
  setTicketPackages(state, ticketPackages) {
    state.ticketPackages = ticketPackages;
  },
  setLoadingPackages(state, loadingPackages) {
    state.loadingPackages = loadingPackages;
  },
  setLoadingExportCSV(state, loadingExportCSV) {
    state.loadingExportCSV = loadingExportCSV;
  },
  setLoadingExportPDF(state, loadingExportPDF) {
    state.loadingExportPDF = loadingExportPDF;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
